export const RESET_EMAIL_KEY = 'reset_email'
